import { JSX, useCallback, useMemo } from "react";

import Link from "@mui/material/Link";

import useFetch from "utils/fetch/useFetch";
import useGet from "utils/fetch/useGet";

import ResourceClient from "resource/ResourceClient";

export type SelectAttachmentProps = {
	id: number;
};

export default function SelectAttachment(
	props: Readonly<SelectAttachmentProps>
): JSX.Element {
	const { response } = useGet(ResourceClient.getInfo(props.id));
	const { call } = useFetch();

	const name = useMemo((): string => {
		return (
			(response.state === "SUCCESS" && response.data.name) ||
			props.id.toString()
		);
	}, [props.id, response.state]);

	const openAttachment = useCallback(() => {
		call(ResourceClient.getContent(props.id)).then(content => {
			const url = window.URL.createObjectURL(content);
			window.open(url, "_blank");
		});
	}, [props.id, name]);

	return (
		<Link sx={{ cursor: "pointer" }} onClick={openAttachment}>
			{name}
		</Link>
	);
}
